import { render, staticRenderFns } from "./UserDelete.vue?vue&type=template&id=22d59952&scoped=true"
import script from "./UserDelete.vue?vue&type=script&lang=js"
export * from "./UserDelete.vue?vue&type=script&lang=js"
import style0 from "./UserDelete.vue?vue&type=style&index=0&id=22d59952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d59952",
  null
  
)

export default component.exports